module.exports = __webpack_public_path__ + "img/DSC_7440.e0006bbf.jpg";